var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.2 393.8L280.1 44.25C274.9 36.08 265.4 32 256 32C246.6 32 237.1 36.08 231.9 44.25L8.807 393.8c-11.11 17.41-11.75 39.42-1.666 57.45C17.07 468.1 35.92 480 56.31 480h399.4c20.39 0 39.24-11.03 49.18-28.77C514.9 433.2 514.3 411.2 503.2 393.8zM256 66.01L346.6 208H256c-5.031 0-9.781 2.375-12.8 6.406L208 261.3L172.8 214.4C170.8 211.7 167.8 210.1 164.7 209.1L256 66.01zM476.9 435.6C472.7 443.2 464.5 448 455.7 448H56.31c-8.826 0-16.97-4.752-21.25-12.39C30.75 427.9 31.02 418.5 35.78 411L144.9 240H152l43.2 57.59C198.2 301.6 202.1 304 208 304s9.781-2.375 12.8-6.406L264 240h103.1l109.2 171C480.1 418.5 481.3 427.9 476.9 435.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/mountain.5f3da1c8d50704d83929718e545fd9d3.svg";
export { ForwardRef as ReactComponent };